module.exports = __webpack_public_path__ + "img/1bit-shield.989e4782.png";